import { Site } from '@/types/template';

import { backendRequest } from './http-client';

/**
 * Lists all sites the authenticated tenant can access. The backend
 * `/v1/sites` endpoint returns conforming contract `Site` objects
 * (timezone, jurisdiction, settings), so no response mapping is needed.
 *
 * @throws Error if the API call fails
 */
export async function listSites(): Promise<Site[]> {
  return backendRequest<Site[]>('/v1/sites', 'Failed to list sites');
}
